module.exports = __webpack_public_path__ + "img/Icon=Tensorflow.b903eaef.svg";